import { KullaniciType } from './../models/KullaniciType';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { M_SERVICE_INFO } from './../models/M_SERVICE_INFO';
import * as moment from 'moment'
import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ActionSheetController, Platform } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { NL_ProgramAyarlari } from '../models/NL_ProgramAyarlari';

declare var require: any;
let { json2excel } = require('js2excel');

// import { Storage } from '@ionic/storage';


// import { M_USER } from '../models/M_USER'
//import { M_SERVICE_INFO } from '../models/M_SERVICE_INFO'



//import * as moment from 'moment'
// import { NativeAudio } from "@ionic-native/native-audio";


// declare var navigator: any;

/*
  Generated class for the Ortak provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Ortak {


  static sqlType = "web";
  static timerOrtak: any;
 

  constructor(public alert?: AlertController,public loadingCtrl?: LoadingController, public actionSheet?: ActionSheetController, public platform?: Platform) {
    // this.nativeAudio.preloadSimple("1", 'assets/audio/Super_Ringtone.mp3');
  }

  turkishToLower(deger) {
    var letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
    deger = deger.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) { return letters[letter]; })
    return deger.toLowerCase();
  }
  public tarih(tarih: Date, format = "YYYY-MM-DD") {
    return moment(tarih).locale("tr").format(format);
  }
  public tarih2(tarih: Date, format = "YYYY-MM-DD hh:mm") {
    return moment(tarih).locale("tr").format(format);
  }



  public get ServisUrl() {
    return this.storageServisBilgisiGetir.ADRES
      +"/Api/Servis.aspx?key=N9ySoNLaS2_18&t=";
  }

  public InternetConnection() {
    //var networkState = navigator.connection.type;
   
    // return Network.type;
  }

  showLoadingControl(contentString) {
    let loading = this.loadingCtrl.create({
      content: contentString
    });
    loading.present();
    return loading;
    
  }

  hideLoadingControl(loadingControl: any) {
    loadingControl.dismiss();
  }
  storageProgramAyarEkle(ayarbilgisi) {
    localStorage.setItem("ayarbilgisi", JSON.stringify(ayarbilgisi));
  }
  showBasicAlert(baslik: string, mesaj: string) {
    let alert = this.alert.create({
      title: baslik,
      subTitle: mesaj,
      buttons: ['Tamam']
    });
    alert.present();
  
  }
  showConfirmAlert(baslik: string, mesaj: string) {
    return new Promise((kabul, ret) => {
      let confirm = this.alert.create({
        title: baslik,
        message: mesaj,
        buttons: [
          {
            text: 'Hayır',
            // handler: () => {
            //   ret();
            // }
          },
          {
            text: 'Evet',
            handler: () => {
              kabul();
            }
          }
        ]
      });
      confirm.present();
    })

  }
  storagePersonelEkle(personel: any) {

   
    localStorage.setItem("personel", JSON.stringify(personel));

  };
  get storagePersonelGetir(): any {
    // return this.storage.get('personel').then((value) => {
    //   return JSON.parse(value);
    // });
    return JSON.parse(localStorage.getItem("personel"));
  }; 
   get StAyarGetir(): NL_ProgramAyarlari {
    return JSON.parse(localStorage.getItem("ayarbilgisi"))
  }
 
  
  showErrorAlert() {
    let alert = this.alert.create({
      title: "Hata",
      subTitle: "İşlem sırasında hata oluştu",
      buttons: ['Tamam']
    });
    alert.present();
  }
  get storageServisBilgisiGetir(): M_SERVICE_INFO {

    return JSON.parse(localStorage.getItem("servisBilgisi"));

  };
  get storagekullanicigetir():KullaniciType{
    return JSON.parse(localStorage.getItem("kullanicibilgisi"));

  };
  get storageGunTarihiGetir(): any {
    // return this.storage.get('personel').then((value) => {
    //   return JSON.parse(value);
    // });
    return localStorage.getItem("gunTarihi");
  };
  get storageSunucuAdresiGetir(): any {
    // return this.storage.get('personel').then((value) => {
    //   return JSON.parse(value);
    // });
    return this.storageServisBilgisiGetir.ADRES;
  };
  storageGunTarihiEkle(gunTarihi) {

    // this.storage.set("personel", JSON.stringify(personel));
    localStorage.setItem("gunTarihi", gunTarihi);

  };
  storageServisBilgisiEkle(servisBilgisi) {

    //this.storage.set("servisBilgisi", JSON.stringify(servisBilgisi));
    localStorage.setItem("servisBilgisi", JSON.stringify(servisBilgisi));
  }
  storagekullaniciekle(kullanicibilgisi){
    localStorage.setItem("kullanicibilfisi",JSON.stringify(kullanicibilgisi));
  }
  alertSmsPenceresi() {
    return new Promise((res, err) => {
      let prompt = this.alert.create({
        title: "Sms Gönder",
        message: "İşleme devam edebilmek için mesaj giriniz.",
        inputs: [
          {
            name: 'Mesaj',
            placeholder: 'Mesajı giriniz.',
            type: 'text',

          },
        ],
        buttons: [

          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {
              err();
            }
          },
          {

            text: 'Tamam',
            role: 'submit',
            handler: data => {
              res({ values: data });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  alertAktarimPenceresi() {
    return new Promise((res, err) => {
      let prompt = this.alert.create({
        title: "Aktarılacak Palsan Sayısını Girin",
        message: "İşleme devam edebilmek için palsan miktarını giriniz.",
        inputs: [
          {
            name: 'Miktar',
            placeholder: 'Miktarı Giriniz.',
            type: 'text',
          },
        ],
        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {
              
            }
          },
          {
            text: 'Tamam',
            role: 'submit',
            handler: data => {
              res({ values: data });
            }
          }
        ]
      });
      prompt.present();
    })
  }
 

  alertSiparisMiktarGuncelle(masa) {
    return new Promise((res, err) => {
      var sonuc = false;
      let prompt = this.alert.create({
        title: "Miktar",
        message: "",
        inputs: [
          {
            name: 'miktar',
            placeholder: 'Miktar',
            type: "number"
          },
          // {
          //   name: 'rezerveDurumu',
          //   type: 'checkbox',
          //   label: 'Rezerve',
          //   value: 'value1',
          //   checked: masa.DURUM_ID == 2 ? true : false,
          // },

        ],
        buttons: [
          // {
          //   text: 'İptal',
          //   handler: data => {
          //     err();
          //   }
          // },
          {
            text: 'Tamam',
            handler: data => {
              sonuc = true;
              res({ values: data, miktar: 0 });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  TurkishToEnglish(phrase) {
    var returnString: string = phrase;

    //Convert Characters
    returnString = returnString.replace(/ö/g, 'o');
    returnString = returnString.replace(/ç/g, 'c');
    returnString = returnString.replace(/ş/g, 's');
    returnString = returnString.replace(/ı/g, 'i');
    returnString = returnString.replace(/ğ/g, 'g');
    returnString = returnString.replace(/ü/g, 'u');
    returnString = returnString.replace(/Ö/g, 'O');
    returnString = returnString.replace(/Ç/g, 'C');
    returnString = returnString.replace(/Ş/g, 'S');
    returnString = returnString.replace(/İ/g, 'I');
    returnString = returnString.replace(/Ğ/g, 'G');
    returnString = returnString.replace(/Ü/g, 'U');
    return returnString;
  }
  formatMoney(girdi, fractionDigits?, decimal?, separator?) {
    if (fractionDigits == null)
      fractionDigits = 2;
    if (decimal == null)
      decimal = ",";
    if (separator == null)
      separator = ".";
    fractionDigits = isNaN(fractionDigits = Math.abs(fractionDigits)) ? 2 : fractionDigits;

    decimal = typeof (decimal) === "undefined" ? "." : decimal;

    separator = typeof (separator) === "undefined" ? "," : separator;

    var number = girdi;

    var neg = number < 0 ? "-" : "";

    var wholePart: any = parseInt(number = Math.abs(+number || 0).toFixed(fractionDigits)) + "";

    var separtorIndex = (separtorIndex = wholePart.length) > 3 ? separtorIndex % 3 : 0;

    return neg +

      (separtorIndex ? wholePart.substr(0, separtorIndex) + separator : "") +

      wholePart.substr(separtorIndex).replace(/(\d{3})(?=\d)/g, "$1" + separator) +

      (fractionDigits ? decimal + Math.abs(number - wholePart).toFixed(fractionDigits).slice(2) : "");


  }
  ExportExcel(data, dosya_ismi: string) {
    return new Promise((res, err) => {
      if (data.length > 0) {
        dosya_ismi = dosya_ismi
        json2excel({
          data,
          name: dosya_ismi,
          formateDate: 'yyyy/mm/dd'
        });
        res();
      }
      else
        err();
    })
  }
  }



// WEBPACK FOOTER //
// ./src/providers/ortak.ts